export const eulerSwapAddresses = {
  eulerSwapV1Factory: "0x45b146BC07c9985589B52df651310e75C6BE066A",
  eulerSwapV1Implementation: "0xd91B0bfACA4691E6Aca7E0E83D9B7F8917989a03",
  eulerSwapV1Periphery: "0xdAAF468d84DD8945521Ea40297ce6c5EEfc7003a",
} as const
